import { getSemiLatestCost, calcSemiCost, getSemiLatestCostDetail } from '@/api/calcSemiCost'
import Vue from 'vue'
import _ from "lodash"

const state = {
  semiItemCostList: [],
  currentSemiItemCost: {},
}

const actions = {
  async getSemiLatestCostAction({ commit }, payload) {
    try {
      const query = _.omit(payload, "update")
      const res = await getSemiLatestCost(query)
      if (payload && payload.update) {
        commit('UPDATE_SEMI_LATEST_COST', res.data)
      } else {
        commit('GET_SEMI_LATEST_COST', res.data)
      }
      
      return res.data
    } catch (error) {
      throw error
    }
  },
  async getSemiLatestCostDetailAction({ commit }, payload) {
    try {
      const res = await getSemiLatestCostDetail(payload)
      commit('GET_SEMI_LATEST_COST_Detail', res.data)
      return res.data
    } catch (error) {
      throw error
    }
  },
  async caclSemiCostAction({ commit }, payload) {
    try {
      const res = await calcSemiCost(payload)
      return res.data
    } catch (error) {
      throw error
    }
  },
}

const mutations = {
  GET_SEMI_LATEST_COST(state, payload) {
    state.semiItemCostList = payload
  },
  GET_SEMI_LATEST_COST_Detail(state, payload) {
    state.currentSemiItemCost = payload
  },
  UPDATE_SEMI_LATEST_COST(state, payload) {
    Vue.set(state.semiItemCostList, state.semiItemCostList.findIndex(x => x._id === payload[0]._id), payload[0]);

  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
}